export default async function UserLogin(senddata) {
    let url = window.UserService + `/api/Users/UserLogin?userName=${senddata.userName }&password=${senddata.password}`
    let response = {}

    let head = {
        "Content-Type": "application/json",
        'accept': '*/*'
    }
    response = await fetch(url, {
        method: "POST",
        headers: head,
        body: JSON.stringify(senddata)
    }).then(res => res.json()).then(response)
    return response;
}